// removed by extract-text-webpack-plugin
module.exports = {"bd":"_2zvHYg8gGnFYBPrTI7WQTJ","clearCookieLink":"UuLU1DsOqAPjvrcXqbfpa","flexcontainer":"_3p3fUVK-DLEBdEDZai8B4t","content":"_1GwZLI4R9sq-OfM-CBTIwf","copyright":"_2ZVbyEh_WhLyd1mHaCMYHw"};


//////////////////
// WEBPACK FOOTER
// ./src/LoginView/LoginView.css
// module id = 127
// module chunks = 0